

export default {

    async SET_TOTAL_LEASE_SUPPLIES_ORDER(state, totalLeaseSuppliiesOrders) {
        state.totalLeaseSuppliesOrders = totalLeaseSuppliiesOrders
    },
    async ADD_NEW_LEASE_SUPPLIES_ORDER(state, order) {
        state.leaseSuppliesOrders.splice(0, 0, order) 
    },
    async SET_LEASE_SUPPLIES_ORDER(state, leaseSuppliesOrders) {
        state.leaseSuppliesOrders = leaseSuppliesOrders
    },
    async UPDATE_LEASE_SUPPLIES_ORDER(state, order) {
        const leaseSuppliesOrderIndex = state.leaseSuppliesOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.leaseSuppliesOrders[leaseSuppliesOrderIndex], order)
    },

    REMOVE_LEASE_SUPPLIES_ORDER(state, idOrder) {
        const leaseSuppliesOrderIndex = state.leaseSuppliesOrders.findIndex((p) => p.idOrder == idOrder)
        state.leaseSuppliesOrders.splice(leaseSuppliesOrderIndex, 1)

    },
    
    

}
 